import { render, staticRenderFns } from "./saleRank.vue?vue&type=template&id=0bed3079&scoped=true&"
import script from "./saleRank.vue?vue&type=script&lang=js&"
export * from "./saleRank.vue?vue&type=script&lang=js&"
import style0 from "./saleRank.vue?vue&type=style&index=0&id=0bed3079&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bed3079",
  null
  
)

export default component.exports